import { Link } from "react-router-dom";

interface ArticleCard {
  slug: string;
  title: string;
  description: string;
  category: string;
  readingTime: string;
  imageUrl: string;
}

const articleCards: ArticleCard[] = [
  {
    slug: "/artykul/kakobuy-spreadsheet-co-to-jest",
    title: "Kakobuy Spreadsheet — Co To Jest?",
    description: "Poznaj definicję, funkcje i zalety kakobuy spreadsheet. Dowiedz się jak to narzędzie rewolucjonizuje zakupy online.",
    category: "Podstawy",
    readingTime: "8 min",
    imageUrl: "https://readdy.ai/api/search-image?query=Organized%20workspace%20with%20open%20laptop%20displaying%20colorful%20spreadsheet%20surrounded%20by%20shopping%20bags%20and%20fashion%20items%20like%20sneakers%20and%20accessories%20on%20a%20clean%20white%20marble%20desk%20with%20natural%20sunlight%20from%20window%20modern%20minimalist%20aesthetic%20bright%20and%20airy%20atmosphere&width=600&height=380&seq=card-what-is-2026-jun&orientation=landscape",
  },
  {
    slug: "/artykul/jak-korzystac-z-kakobuy-spreadsheet",
    title: "Jak Korzystać z Kakobuy Spreadsheet?",
    description: "Kompletny poradnik krok po kroku dla początkujących i zaawansowanych użytkowników narzędzia.",
    category: "Poradniki",
    readingTime: "10 min",
    imageUrl: "https://readdy.ai/api/search-image?query=Close%20up%20of%20hands%20interacting%20with%20a%20digital%20tablet%20showing%20product%20listings%20with%20shopping%20cart%20icons%20colorful%20sticky%20notes%20and%20a%20coffee%20cup%20nearby%20on%20a%20warm%20wooden%20desk%20cozy%20home%20office%20vibe%20with%20soft%20afternoon%20light&width=600&height=380&seq=card-how-to-2026-jun&orientation=landscape",
  },
  {
    slug: "/artykul/najlepszy-kakobuy-spreadsheet-2026",
    title: "Najlepszy Kakobuy Spreadsheet 2026",
    description: "Porównujemy dostępne wersje i wskazujemy najlepsze arkusze dla różnych potrzeb zakupowych.",
    category: "Rankingi",
    readingTime: "12 min",
    imageUrl: "https://readdy.ai/api/search-image?query=Trophy%20on%20a%20pedestal%20surrounded%20by%20fashion%20products%20including%20designer%20sneakers%20luxury%20bags%20and%20stylish%20accessories%20arranged%20in%20a%20circular%20pattern%20on%20a%20dark%20marble%20surface%20dramatic%20gallery%20lighting%20premium%20editorial%20style&width=600&height=380&seq=card-best-2026-jun&orientation=landscape",
  },
  {
    slug: "/artykul/kakobuy-spreadsheet-polska",
    title: "Kakobuy Spreadsheet Polska",
    description: "Specjalna edycja dostosowana do potrzeb polskich kupujących. Wysyłka, cła i koszty.",
    category: "Polska",
    readingTime: "9 min",
    imageUrl: "https://readdy.ai/api/search-image?query=Fashion%20products%20and%20shopping%20packages%20arranged%20on%20a%20surface%20with%20subtle%20red%20and%20white%20accents%20inspired%20by%20Polish%20flag%20colors%20elegant%20minimalist%20composition%20with%20soft%20natural%20lighting%20clean%20Scandinavian%20aesthetic%20warm%20neutral%20background&width=600&height=380&seq=card-poland-2026-jun&orientation=landscape",
  },
  {
    slug: "/artykul/czy-kakobuy-jest-bezpieczny",
    title: "Czy Kakobuy Jest Bezpieczny?",
    description: "Szczegółowa analiza bezpieczeństwa platformy. Mechanizmy ochrony i potencjalne zagrożenia.",
    category: "Bezpieczeństwo",
    readingTime: "11 min",
    imageUrl: "https://readdy.ai/api/search-image?query=Shield%20and%20lock%20symbols%20floating%20protectively%20above%20online%20shopping%20products%20on%20a%20serene%20pastel%20mint%20green%20background%20soft%20glowing%20protection%20bubble%20effect%20clean%20modern%20digital%20security%20concept%20trustworthy%20and%20calm%20atmosphere&width=600&height=380&seq=card-safety-2026-jun&orientation=landscape",
  },
  {
    slug: "/artykul/kakobuy-vs-allchinabuy",
    title: "Kakobuy vs AllChinaBuy",
    description: "Porównanie dwóch gigantów zakupowych. Ceny, czas dostawy i jakość obsługi w 2026.",
    category: "Porównania",
    readingTime: "10 min",
    imageUrl: "https://readdy.ai/api/search-image?query=Two%20shopping%20carts%20side%20by%20side%20with%20different%20product%20collections%20one%20with%20warm%20golden%20toned%20products%20the%20other%20with%20cool%20silver%20toned%20items%20on%20a%20split%20background%20clean%20comparison%20layout%20modern%20editorial%20style&width=600&height=380&seq=card-vs-allchina-2026-jun&orientation=landscape",
  },
  {
    slug: "/artykul/kakobuy-vs-orientdig",
    title: "Kakobuy vs OrientDig",
    description: "Szczegółowe zestawienie platform. Różnice w ofercie i doświadczeniach użytkowników.",
    category: "Porównania",
    readingTime: "9 min",
    imageUrl: "https://readdy.ai/api/search-image?query=Two%20product%20collections%20on%20separate%20display%20platforms%20illuminated%20by%20contrasting%20warm%20terracotta%20and%20cool%20teal%20spotlights%20in%20a%20darkened%20gallery%20space%20dramatic%20museum%20style%20presentation%20elegant%20and%20sophisticated&width=600&height=380&seq=card-vs-orientdig-2026-jun&orientation=landscape",
  },
  {
    slug: "/artykul/kakobuy-vs-superbuy",
    title: "Kakobuy vs Superbuy",
    description: "Starcie gigantów zakupowych. Która platforma jest lepsza dla polskich klientów?",
    category: "Porównania",
    readingTime: "11 min",
    imageUrl: "https://readdy.ai/api/search-image?query=Two%20towering%20stacks%20of%20fashion%20products%20facing%20each%20other%20like%20competitors%20in%20an%20arena%20with%20dramatic%20overhead%20lighting%20casting%20dynamic%20shadows%20on%20a%20polished%20floor%20intense%20versus%20concept%20bold%20editorial%20style&width=600&height=380&seq=card-vs-superbuy-2026-jun&orientation=landscape",
  },
  {
    slug: "/artykul/najlepszy-agent-zakupowy-polska",
    title: "Najlepszy Agent Zakupowy w Polsce",
    description: "Kompletny ranking wszystkich agentów dostępnych dla polskich klientów w 2026 roku.",
    category: "Rankingi",
    readingTime: "13 min",
    imageUrl: "https://readdy.ai/api/search-image?query=Winner%20podium%20with%20first%20second%20and%20third%20place%20featuring%20shopping%20products%20on%20each%20tier%20surrounded%20by%20golden%20confetti%20on%20a%20sophisticated%20champagne%20colored%20background%20elegant%20celebration%20vibe%20premium%20award%20ceremony%20style&width=600&height=380&seq=card-best-agent-2026-jun&orientation=landscape",
  },
];

export default function ArticlesSection() {
  return (
    <section id="artykuly" className="py-20 md:py-28 bg-background-100 scroll-mt-16 md:scroll-mt-[72px]">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <p className="text-xs md:text-sm text-secondary-600 font-medium tracking-widest uppercase mb-4">
            Artykuły SEO
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 mb-3">
            Przewodniki i{" "}
            <span className="text-primary-500">Poradniki</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            Oryginalne artykuły o kakobuy spreadsheet — pisane przez ekspertów, zoptymalizowane pod SEO
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articleCards.map((card) => (
            <Link
              key={card.slug}
              to={card.slug}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative h-[180px] md:h-[200px] overflow-hidden">
                <img
                  src={card.imageUrl}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-700">
                    {card.category}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors mb-2 leading-snug">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-4 flex-1">
                  {card.description}
                </p>
                <div className="flex items-center justify-between pt-3 border-t border-background-200/60">
                  <span className="text-xs text-foreground-500">{card.readingTime} czytania</span>
                  <span className="w-5 h-5 flex items-center justify-center text-primary-400 group-hover:translate-x-1 transition-transform">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-xs text-foreground-400">
            Kliknij dowolny artykuł, aby przeczytać pełną treść. Wszystkie artykuły zawierają wewnętrzne linki do strony głównej.
          </p>
        </div>
      </div>
    </section>
  );
}